<ion-grid
	class="max-w-1336 content-box"
	*ngIf="getCourseList$ | async as courses"
>
	<ng-container *ngIf="courses.isSkeleton">
		<ion-grid class="side-menu-wrapper text-center">
			<ion-spinner class="ion-spinner"></ion-spinner>
		</ion-grid>
	</ng-container>
	<ion-row>
		<ion-col class="grid-container">
			<ion-card
				color="light"
				*ngFor="let course of courses.data"
				(click)="viewInfo(course.id)"
				class="grid-item"
			>
				<!-- <div class="course-image">
					<img src="course.multimedia" alt="course-image" />
				</div> -->
				<div class="course-content">
					<ion-card-header>
						<ion-card-title>{{course.name}}</ion-card-title>
					</ion-card-header>

					<ion-card-content> {{course.description}} </ion-card-content>
				</div>
			</ion-card>
		</ion-col>
	</ion-row>
</ion-grid>
